// extracted by css-extract-rspack-plugin
export default {"checkbox":"kZKUByiLw0EwdXi5"};